import FindingsList from './FindingsList';

// CSPM (Security Hub) findings. The default FindingsList source (listFindings)
// returns CSPM findings; FindingDetail routes each to CspmDetailBody.
export default function CspmFindings() {
  return <FindingsList subtitle="Security Hub CSPM findings" />;
}
